import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'login',
            component: () =>
                import ('@/views/OnBoarding/login/login')
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ('@/views/OnBoarding/login/login')
        },
        {
            path: '/otp',
            name: 'OTP',
            component: () =>
                import ('@/views/OnBoarding/login/otp')
        },
        {
            path: '/forgot-password',
            name: 'forget password',
            component: () =>
                import ('@/views/OnBoarding/login/forgot-password')
        },
        {
            path: '/reset-password',
            name: 'reset password',
            component: () =>
                import ('@/views/OnBoarding/login/reset-password')
        },
        {
            path: '',
            name: 'Main',
            component: () =>
                import ('@/views/main'),
            meta: {
                requiresAuth: true
            },
            children: [
                // dashboard
                {
                    path: '/dashboard',
                    name: 'Dashboard',
                    component: () =>
                        import ('@/views/OnBoarding/dashboard/dashboard')
                },
                // Manage Users
                {
                    path: '/salon-manager',
                    name: 'Salon Manager',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/salon-manager')
                }, {
                    path: '/salon-manager-detail/:id',
                    name: 'Salon Manager Detail',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/salon-manager-detail')
                }, {
                    path: '/add-new-manager',
                    name: 'Add New Manager',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/add-new-manager')
                }, {
                    path: '/edit-new-manager/:id',
                    name: 'Edit Manager',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/add-new-manager')
                }, {
                    path: '/customer-user',
                    name: 'Customer User',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/customer-user')
                },
                {
                    path: '/customer-user-detail/:id',
                    name: 'Customer User Detail',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/customer-user-detail')
                },
                {
                    path: '/add-new-customer',
                    name: 'Add New Customer',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/edit-customer-detail')
                },
                {
                    path: '/edit-customer-detail/:id',
                    name: 'Edit Customer Detail',
                    component: () =>
                        import ('@/views/OnBoarding/ManageUsers/edit-customer-detail')
                },
                // payment
                {
                    path: '/manage-payment',
                    name: 'Manage Payment',
                    component: () =>
                        import ('@/views/OnBoarding/Payment/manage-payment')
                }, {
                    path: '/set-fee-rate',
                    name: 'Set Fee Rate',
                    component: () =>
                        import ('@/views/OnBoarding/Payment/set-fee-rate')
                },
                // CMS
                {
                    path: '/manage-terms-and-condition',
                    name: 'Manage Terms And Condition',
                    component: () =>
                        import ('@/views/OnBoarding/CMS/manage-terms-and-condition')
                }, {
                    path: '/manage-privacy-policy',
                    name: 'Manage Privacy Policy',
                    component: () =>
                        import ('@/views/OnBoarding/CMS/manage-privacy-policy')
                },
                {
                    path: '/cms',
                    name: 'Cms',
                    component: () =>
                        import ('@/views/OnBoarding/CMS/cms')
                },
                // Manage Service
                {
                    path: '/manage-services',
                    name: 'Manage Services',
                    component: () =>
                        import ('@/views/OnBoarding/ManageServices/manage-services')
                },
                {
                    path: '/manage-style',
                    name: 'Manage Style',
                    component: () =>
                        import ('@/views/OnBoarding/ManageServices/manage-style')
                },
                //    manage Complaints
                {
                    path: '/manage-complaints',
                    name: 'Manage Complaints',
                    component: () =>
                        import ('@/views/OnBoarding/ManageComplaints/manage-complaints')
                },
                {
                    path: '/my-profile',
                    name: 'My Profile',
                    component: () =>
                        import ('@/views/OnBoarding/MyProfile/my-profile')
                },
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            if (localStorage.getItem('access_token') == null) {
                next({
                    path: '/',
                    params: { nextUrl: to.fullPath }
                })
            } else {
                next()
            }
        } else {
            if (to.fullPath == '/' && localStorage.getItem('access_token') != null) {
                next('/dashboard')
            } else {
                next()
            }
        }
    }


)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js